import Dropzone from "react-dropzone";
import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import TrendingUp from "@material-ui/icons/TrendingUp";
import TrendingDown from "@material-ui/icons/TrendingDown";
import Add from "@material-ui/icons/Add";
import Amplify, { Auth, Storage } from "aws-amplify";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import TextField from "@material-ui/core/TextField";
import API from "@aws-amplify/api";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import awsmobile from "./../../aws-exports";
Amplify.configure(awsmobile);
// core components
const uuidv4 = require("uuid/v4");
const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};
let apiName = process.env.REACT_APP_AMPLIFY_API;

class Kickbox extends React.Component {
  constructor() {
    super();
    this.state = {
      files: null,
    };
  }

  submitFile = (event) => {
    event.preventDefault();
    for (let i = 0; i < this.state.file.length; i++) {
      const uuidv1 = require("uuid/v1");
      Storage.put(this.state.file[i]["name"], this.state.file[i], {
        customPrefix: {
          public:
            "data/landing/validations/kickbox/list=" +
            String(uuidv1()) +
            "/client=1/" +
            "type=preclub/",
        },
      })
        .then((result) => console.log(result)) // {key: "test.txt"}
        .catch((err) => console.log(err));
    }
  };

  handleFileUpload = (event) => {
    this.setState({ file: event.target.files });
  };

  render() {
    return (
      <div>
        <h1>KICKBOX</h1>
        <h1>KICKBOX</h1>
        <h1>KICKBOX</h1>
        <h1>KICKBOX</h1>
        <form onSubmit={this.submitFile}>
          <input
            label="upload file"
            type="file"
            multiple
            onChange={this.handleFileUpload}
          />
          <button type="submit">Send</button>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(Kickbox);



// WEBPACK FOOTER //
// ./src/views/Kickbox/Kickbox.jsx